module.exports = __webpack_public_path__ + "static/media/parking-logo.86c6253c.png";